import * as React from "react"
import { TextField } from "@mui/material"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker"
import { FormField } from "./types"
import { useController, useFormContext } from "react-hook-form"

import styles from "./Forms.module.scss"
import { trackFormEvent } from "./utils"

export interface Props extends FormField {}

const DatePicker = ({ label, name, rules, tracking, className }: Props) => {
  const { control, formState } = useFormContext()
  const controller = useController({ name, control, rules })

  const handleDateSelect = async (date: Date | null) => {
    controller.field.onChange(date)

    if (tracking?.shouldTrackValueChange && date) {
      await trackFormEvent("Form Value Provided", tracking, name, label)
    }
  }

  const error = formState.errors[name]
  const errorProps = error ? { error: true, label: error.message?.toString() } : {}

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        label={label}
        inputFormat="dd/MM/yyyy"
        PaperProps={{ className: styles.datePickerPopper }}
        PopperProps={{ disablePortal: true }}
        renderInput={(params) => <TextField {...params} {...errorProps} className={className} />}
        value={controller.field.value}
        onChange={handleDateSelect}
      />
    </LocalizationProvider>
  )
}

export default DatePicker
